import React, {useEffect, useState} from 'react'
import Ajax from '../../../../../helpers/Ajax'
import TableLoader from '../../../../UI/Dashboard/TableLoader';
import DataView from '../../../../UI/Dashboard/DataView';
import TableContainer from '../../../../UI/Dashboard/TableContainer';
import { Helmet } from 'react-helmet-async';
import ContentLayout from '../../../../Common/ContentLayout';
import EditButton from '../../../../UI/Dashboard/EditButton';

export default function AboutContent() {
    const [listData, setListData] = useState(null)
    useEffect(()=>{
    const getResponse = setTimeout(function(){  
        (async()=>{ 
        const response = await Ajax({
            url: `/about/heading`,
            token: true,
        })
        if(response.data.status === "SUCCESS!"){
            setListData(response.data.result)
        }
        })()
    },100) 
    return()=>{
        clearInterval(getResponse)
    }
    },[])

    return (
    <ContentLayout title='About Us'>
        <div className="row">
        <Helmet>
            <title>About Us</title>
        </Helmet>
        <DataView title="About Us List">
            <TableContainer>
                <thead>
                    <tr>
                        <td className="text-center">S.No</td>
                        <td className="text-start">Title</td>
                        <td className="text-start" width="70%">Description</td>
                        <td className="text-center">Action</td>
                    </tr>
                </thead>
                <tbody>
                    {listData == null ? 
                    <TableLoader cols={4}/> : listData.length === 0 ? 
                    <tr>
                        <td colSpan={4} className="text-center">Data not available</td>
                    </tr> : listData.map((data, index)=>(
                    <tr key={data._id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start">{data.weareTitle}</td>
                        <td className="text-start">{data.weareDescription}</td>
                        <td className="text-center">
                            <EditButton>{`/admin/about/${data._id}`}</EditButton>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </TableContainer>
        </DataView>
    </div>
    </ContentLayout>
    )
}
